import { Card, CardContent } from '@mui/material';
import { PropsWithChildren } from 'react';

import { NoddiCardProps } from '../../../types';
import { NoddiHeader } from '../NoddiHeader';

const NoddiCardContent = ({ children, cardContentSx }: PropsWithChildren<Pick<NoddiCardProps, 'cardContentSx'>>) => (
  <CardContent sx={cardContentSx}>
    <div className='flex flex-col gap-1'>{children}</div>
  </CardContent>
);

export const NoddiCard = ({
  title,
  description,
  headerNode,
  children,
  cardSx,
  cardContentSx
}: PropsWithChildren<NoddiCardProps>) => (
  <Card sx={cardSx}>
    {(title || description || headerNode) && (
      <NoddiHeader
        title={title}
        description={description}
        node={headerNode}
        sx={{ paddingX: '24px', paddingTop: '32px', paddingBottom: '0px' }}
        titleVariant='h5'
      />
    )}

    <NoddiCardContent cardContentSx={cardContentSx}>{children}</NoddiCardContent>
  </Card>
);
